import BaseModel from './BaseModel';

export default class Item extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.code = data.code || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.uom = data.uom || undefined;
        this.priceBeforeTax = data.priceBeforeTax || 0;
        this.taxInfo = data.taxInfo || { scv: 0, sct: 0, vat: 0 };
        this.priceAfterTax = data.priceAfterTax || 0;
        
        // Detailed Info
        this.images = data.images || [];
        this.description = data.description || '';
        
        this.modifiedPrice = data.modifiedPrice || undefined;
        this.condiments = data.condiments || [];
        this.options = data.options || [];
        this.labels = data.labels || [];

        // Translation Alert Flags
        this.translationChanged = data.translationChanged || {}; // { description: true, options: false }
    }
}
